module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "10%",
      "margin-top": "3em"
    }
  }, [_c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction",
      "id": "introduction"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1",
      "id": "chapter1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#C4084A"
    }
  }, [_vm._v("Cookies")])])]), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2",
      "id": "chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#C4084A"
    }
  }, [_vm._v("Cupcakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3",
      "id": "chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#C4084A"
    }
  }, [_vm._v("Whoopie Pies ")])])]), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4",
      "id": "chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#C4084A"
    }
  }, [_vm._v("Doughnuts ")])])]), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5",
      "id": "chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Metric Conversions and Equivalents")])])]), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgments",
      "id": "acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Acknowledgments ")])])]), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "id": "index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }), _vm._v(" "), _c('p', {
    staticClass: "initial"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "id": "author",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("About Sur La Table")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-980d9f98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content.vue
// module id = 72
// module chunks = 0